import { Link } from 'react-router-dom';

export default function ProductCTA() {
  return (
    <section className="py-20 bg-gradient-to-br from-teal-600 to-cyan-700">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center text-white">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            准备开始您的
            <span className="text-teal-200"> 文档智能化</span> 之旅？
          </h2>
          <p className="text-xl text-teal-100 mb-12 max-w-3xl mx-auto leading-relaxed">
            无论您是开发者、企业用户还是系统集成商，我们都有适合您的解决方案。立即联系我们，获取专业的产品咨询和定制化建议。
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-16">
            <Link
              to="/contact"
              className="bg-white text-teal-600 hover:bg-teal-50 px-8 py-4 rounded-xl font-bold text-lg transition-colors whitespace-nowrap cursor-pointer shadow-lg"
            >
              联系销售团队
            </Link>
            <Link
              to="/contact"
              className="border-2 border-white text-white hover:bg-white hover:text-teal-600 px-8 py-4 rounded-xl font-bold text-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              申请免费试用
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">电话咨询</h3>
              <p className="text-teal-100 mb-3">专业销售顾问为您提供一对一咨询服务</p>
              <p className="text-white font-semibold">400-838-9650</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">邮件联系</h3>
              <p className="text-teal-100 mb-3">发送邮件获取详细产品资料和报价</p>
              <p className="text-white font-semibold">hello@documogul.com</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">预约演示</h3>
              <p className="text-teal-100 mb-3">安排在线产品演示，深入了解功能特性</p>
              <Link 
                to="/contact"
                className="text-white font-semibold hover:text-teal-200 transition-colors cursor-pointer"
              >
                立即预约 →
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}